<template>
  <v-app-bar app color="primary" dark>
    <v-app-bar-nav-icon @click="toggleNav">
      <v-icon>mdi-menu</v-icon>
    </v-app-bar-nav-icon>
    <v-toolbar-title>{{ $route.meta.title }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn @click="signout" icon><v-icon>mdi-logout</v-icon></v-btn>
  </v-app-bar>
</template>

<script>
export default {
  methods: {
    toggleNav () {
      this.$store.commit('nav/toggle')
    },
    async signout () {
      try {
        await this.$store.dispatch('signout')
      } catch (err) {
        alert(err.message)
      } finally {
        location.href = '/signin'
      }
    }
  }
}
</script>
